import { ConfigDHL } from 'src/app/modules/dhl/config/config';
import { DHLModule } from 'src/app/modules/dhl/dhl.module';

export const facilityModule = DHLModule;

export const configFacility = ConfigDHL;
